<template>
    <div class="contact" id="contact">
        <div class="container">
            <div class="row">
                <!-- Section Header -->
                <div class="section-header">
                    <h2 class="section-title">Контакты</h2>
                    <h3 class="section-subtitle">
                        Остались вопросы? <br>
                        Свяжитесь с нами, сделаем все что в наших силах
                    </h3>
                </div>
                <div class="col-xs-12 animateblock btt speed-1">
                    <form class="contact-form">
                        <div class="contact-form-box form-group">
                            <input type="text" placeholder="Имя" class="form-control">
                        </div>
                        <div class="contact-form-box form-group">
                            <input type="email" placeholder="Email" class="form-control">
                        </div>
                        <div class="contact-form-box msg form-group">
                            <textarea name="message" placeholder="Сообщение" class="form-control"></textarea>
                        </div>
                        <button type="submit" class="btn btn-danger">
                            Отправить
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Contacts",
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// Contacts.vue?477addfa